import React from 'react';
import { getStatusColor } from '../../../../utils/helpers';

interface StatusChipProps {
  status: string;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function StatusChip({
  status,
  label,
  size = 'md',
}: StatusChipProps) {
  const colorClass = getStatusColor(status);

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-[10px] font-medium rounded-full',
    md: 'px-2.5 py-0.5 text-xs font-semibold rounded-full',
    lg: 'px-3 py-1 text-sm font-semibold rounded-full',
  };

  const capitalize = (str: string) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <span
      className={`inline-flex items-center justify-center whitespace-nowrap font-medium ${sizeClasses[size]} ${colorClass}`}
    >
      {label ?? capitalize(status)}
    </span>
  );
}
